import { TranslationRO } from '@routellers/types/dist/translation/translation.ro';

import { ApiMethodDeclaration } from '..';

/** ID city */
type ParamsData = number;

type ResponseData = TranslationRO;

export const removeTranslation: ApiMethodDeclaration<ParamsData, ResponseData> = (id) => ({
    url: `/translations/${id}`,
    method: 'DELETE',
});
